export const layout = {
  options: [
    { label: 'Full Bleed', value: 'container' },
    { label: 'Padded', value: 'padded' },
    { label: 'Contained (Narrow)', value: 'contentNarrow' },
    { label: 'Contained (Medium)', value: 'content' },
    { label: 'Contained (Wide)', value: 'contentWide' },
  ],
  value: {
    container: 'container',
    padded: 'padded',
    contentNarrow: 'contentNarrow',
    content: 'content',
    contentWide: 'contentWide',
  },
};
